@if (activePermission) {
  <ion-item color="warning" class="lp-font-weight-400 lp-font-size-14">
    <ion-label>
      Viewing: {{ activePermission.requester_first_name }}
      {{ activePermission.requester_last_name }}
    </ion-label>
  </ion-item>
}
